import { push } from 'react-router-redux';
import parseText from '../pattern_utilities/parseText';
import generateText from '../pattern_utilities/generateText';
import {tryToUpdatePattern, hideTooltip} from './actions.export.js';

export * from './pattern/a.p.POST.new-pattern.js';
export * from './pattern/a.p.POST.save-a-copy.js';
export * from './pattern/a.p.GET.load-pattern.js';
export * from './pattern/a.p.GET.official-patterns.js';
export * from './pattern/a.p.GET.my-patterns.js';
export * from './pattern/a.p.GET.team-patterns.js';
export * from './pattern/a.p.PUT.update-pattern.js';
export * from './pattern/a.p.DELETE.pattern.js';
export * from './pattern/a.p.POST.calculate-pattern.js';
export * from './pattern/a.p.POST.render-pattern.js';
export * from './pattern/a.p.PUT.stats-download.js';

var autoSaveTimeout;
var autoSaveTimeoutMillis = 2000;

function runAutoSave(packet, dispatch, getState){
  if(packet.cacheID !== 'local' && getState().patternManager.cache[packet.cacheID].linkedToServer && getState().globalReducer.autoSave){
    clearTimeout(autoSaveTimeout);
    autoSaveTimeout = setTimeout(function(){
      dispatch(tryToUpdatePattern(getState().patternManager.cache[packet.cacheID]));
    }, autoSaveTimeoutMillis);
  }
}

export const leavePattern = data => ({
  type: 'LEAVE_PATTERN',
  data
})

export const updateFromText = data => ({
  type: 'UPDATE_FROM_TEXT',
  data
})


export const updateFromData = data => ({
  type: 'UPDATE_FROM_DATA',
  data
})
export const updateFromScale = data => ({
  type: 'UPDATE_FROM_SCALE',
  data
})
export const updateFromRotate = data => ({
  type: 'UPDATE_FROM_ROTATE',
  data
})

export const forgetChanges = data => ({
  type: 'FORGET_CHANGES',
  data
})

export const pmUpdateFromText = packet => (dispatch, getState) => {
  dispatch(updateFromText(packet));
  runAutoSave(packet, dispatch, getState);
}

export const pmUpdateFromHybrid = packet => (dispatch, getState) => {
  dispatch(updateFromData(packet));
  runAutoSave(packet, dispatch, getState);
}

export const createBlankPattern = data => ({
  type: 'CREATE_BLANK_PATTERN',
  data
})

export const revertToPristine = data => ({
  type: 'REVERT_TO_PRISTINE',
  data
})

export const newBlankPattern = packet => (dispatch, getState) => {
  dispatch(createBlankPattern(packet));
}

export const createDrawingPattern = data => ({
  type: 'CREATE_DRAWING_PATTERN',
  data
})


export const newDrawingPattern = packet => (dispatch, getState) => {
  dispatch(createDrawingPattern(packet));
}

export const downloadText = data => ({
  type: 'DOWNLOAD_TEXT',
  data
})

export const uploadPATFile = packet => (dispatch, getState) => {

  let reader = new FileReader();
  let team = getState().team;
  reader.onload = function(event) {
    let data = event.target.result;

    let pattern = parseText(data);
    pattern.text = generateText(pattern);
    pattern.tags = [];
    pattern.projects = [];

    
    dispatch(push('/new/imported'));
    

    dispatch(pmUpdateFromHybrid({
      pattern: pattern,
      cacheID: packet.cacheID,
      regenText: false
    }));

    dispatch(hideTooltip());
  }

  if(packet.file){
    return reader.readAsText(packet.file)
  } else {
    dispatch(newBlankPattern());
  }
}


export const undo = packet => (dispatch, getState) => {
  dispatch(internalUndo(packet));
  runAutoSave(packet, dispatch, getState);
}


const internalUndo = data => ({
  type: 'UNDO',
  data
})


export const redo = packet => (dispatch, getState) => {
  dispatch(internalRedo(packet));
  runAutoSave(packet, dispatch, getState);
}

const internalRedo = data => ({
  type: 'REDO',
  data
})


export const alignText = packet => (dispatch, getState) => {
  
  dispatch(updateFromData(packet));
  runAutoSave(packet, dispatch, getState);
}


export const collapseColumns = packet => (dispatch, getState) => {
  dispatch(updateFromData(packet));
  runAutoSave(packet, dispatch, getState);
}


export const removeBlankLines = packet => (dispatch, getState) => {
  var patternManager = getState().patternManager;
  var pat = patternManager.cache[patternManager.current_pattern];
  var lines = pat.text.split(/\r?\n/);
  var newText = '';
  for(var i = 0; i < lines.length; i++){
    if(lines[i].trim() === ''){
      lines.splice(i, 1);
      i--;
    }
  }

  for(i in lines){
    newText += lines[i];
    if(i < lines.length - 1){
      newText += '\r\n';
    }
  }

  dispatch(updateFromText({
    cacheID: patternManager.current_pattern,
    pattern: parseText(newText)
  }));
  runAutoSave({ cacheID: patternManager.current_pattern }, dispatch, getState);
}


export const removeComments = packet => (dispatch, getState) => {
  var patternManager = getState().patternManager;
  var pat = patternManager.cache[patternManager.current_pattern];
  var lines = pat.text.split(/\r?\n/);
  var newText = '';
  for(var i = 0; i < lines.length; i++){
    if(lines[i].length === 1){
      if(lines[i] === ';'){
        lines.splice(i, 1);
        i--;  
        continue;
      }
    } else if(lines[i][0] === ';' && lines[i][1] !== '%'){
      lines.splice(i, 1);
      i--;
      continue;
    }
  }

  for(i in lines){
    newText += lines[i];
    if(i < lines.length - 1){
      newText += '\r\n';
    }
  }

  dispatch(updateFromText({
    cacheID: patternManager.current_pattern,
    pattern: parseText(newText)
  }));
  runAutoSave({ cacheID: patternManager.current_pattern }, dispatch, getState);
}



// WEBPACK FOOTER //
// ./src/actions/actions.patternManager.js